<div class="fulfillmentLanding">
  <div *ngIf="productLine != 'All' && (bannerMessage != null && bannerMessage != '')" class="status-bar">
    {{bannerMessage}}
  </div>
</div>
<div class="fulfillmentLanding seed-return-wrapper">
  <div class="seedReturnLandingPage">
    <div class="row">
      <div class="col-md-12 col-lg-12 margin-l0 TopSec">
        <h3>
          Seed Returns<img src="{{imagePath}}" class="xs-ml-10 xs-mr-10"><span *ngIf="productLine != 'All'">{{productLine}}</span><span *ngIf="productLine == 'All'">View All Returns</span>
        </h3>
        <p class="smalltext">
          Filter return requests by choosing the type of filter you`d like to use and searching for a value. You may opt to view your submitted returns on the tab below, or see your saved drafts by selecting return request drafts tab.
        </p>
      </div>
    </div>
    <div class="form-sec">
      <div class="row margin-t10 margin-b10 margin-r0">
        <div class="col-sm-10 col-md-10 col-lg-10 smallPadRgt0 margin-l0">
          <div class="row search-box-outer ">
            <div class="col-md-3 col-lg-2 padding-r0 category-drop-outer borderRight">

              <div class="category-dropdown material-select">
                <ng-select [items]="searchTypeList"
                           name="ddlProductSearch"
                           [(ngModel)]="selectedValue"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           bindValue="value"
                           labelForId="name"
                           [searchable]="false"
                           (change)="retainFilter(null, ' ')">
                </ng-select>
              </div>
            </div>
            <div class="col-md-10 col-lg-10 padding-l4 padding-r0 ">
              <div class="row material-select seed-search-filter">
                <ng-select #notification name="ddlNotificationSearch" *ngIf="selectedValue === 'By Notification'"
                           [items]="notificationList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.Notification"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(notification,'Notification')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <!--<div #productSearch *ngIf="selectedValue === 'Product Name'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getReturnRequestList();" [(ngModel)]="productFilters.ProductName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>-->

                <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                           [items]="itemList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ItemNo"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(itemNo,'ItemNo')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <ng-select #AccountNo *ngIf="selectedValue === 'Account' && isEvolveAccountRestriction == true"
                           [items]="ddlAccounts"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.AccountNo"
                           [virtualScroll]="true"
                           bindLabel="accountNameCityState"
                           bindValue="accountNumber"
                           [closeOnSelect]="true"
                           [searchFn]="accountSearchFn"
                           (change)="retainFilter(null, ' ')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row" *ngIf="item.accountNumber!=-1">
                        <div class="col-md-8">
                          <h4 class="name greenColor" [ngOptionHighlight]="search">
                            {{item.accountName}}
                          </h4>
                          <p class="address" [ngOptionHighlight]="search">
                            {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                          </p>
                          <p class="phoneNo" [ngOptionHighlight]="search">
                            {{item.primaryPhoneNumber}}
                          </p>
                          <p class="grower-nos">
                            <span class="grower-gln" [ngOptionHighlight]="search">
                              Account #: {{item.accountNumber}}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="row" *ngIf="item.accountNumber==-1">
                        <div class="col-md-8">
                          <h4 class="name" [ngOptionHighlight]="search">
                            {{item.accountName}}
                          </h4>
                          <p class="grower-nos">
                            <span class="grower-gln" [ngOptionHighlight]="search">
                              Account #: {{item.accountNumber}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <div #productSearch *ngIf="selectedValue === 'Account Name' && isEvolveAccountRestriction == false " class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getReturnRequestList();" [(ngModel)]="productFilters.AccountName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div #productSearch *ngIf="selectedValue === 'Account Number' && isEvolveAccountRestriction == false" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getReturnRequestList();" [(ngModel)]="productFilters.TxtAccountNo"
                               placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                      </div>
                    </div>
                  </div>
                </div>
                <div #productSearch *ngIf="selectedValue === 'Account City' && isEvolveAccountRestriction == false" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getReturnRequestList();" [(ngModel)]="productFilters.AccountCity"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div #productSearch *ngIf="selectedValue === 'Account State' && isEvolveAccountRestriction == false" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getReturnRequestList();" [(ngModel)]="productFilters.AccountState"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Request Date'">
                  <div class="text-center deliveryDatePicker">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromOrderDateFilter"
                             readonly [(ngModel)]="productFilters.FromOrderDate" (dateChange)="retainFilter(null, ' ');validateOrderDateFilter('fromOrderDate', $event);">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Request Date'">
                  <div class="text-center deliveryDatePicker">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toOrderDateFilter"
                             readonly [(ngModel)]="productFilters.ToOrderDate" (dateChange)="retainFilter(null, ' ');validateOrderDateFilter('toOrderDate', $event);">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div *ngIf="selectedValue == 'Request Number'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ');getReturnRequestList();" [(ngModel)]="productFilters.ReturnRequestNumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="selectedValue == 'Customer PO#'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ')" [(ngModel)]="productFilters.CustomerPO"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="selectedValue == 'Branch Plant'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter(null, ' ')" [(ngModel)]="productFilters.BranchPlant"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <ng-select #productLineFilter name="ddlProductLine" *ngIf="selectedValue === 'Product Line'"
                           [items]="productLineList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ProductLineFilter"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="id"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(productLineFilter,'ProductLineFilter')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <ng-select #processingStatus name="ddlItemNoSearch" *ngIf="selectedValue === 'Status'"
                           [items]="processingStatusList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ProcessingStatus"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="retainFilter(processingStatus,'ProcessingStatus')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="search-btn">
                <button mat-raised-button class="btns" (click)="retainFilter(null, ' ');getReturnRequestList();" color="primary">Search</button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center ml-5 fs">
          <button mat-raised-button class="btns" (click)="exportReturnRequest()">Export</button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 padding-r0">
          <div class="chips-sec">
            <div class="row selected-chip">
              <div class="col-sm-9 col-md-10 padding-l0">
                <div>
                  <mat-chip-set>
                    <mat-chip selected *ngFor="let filterValue of filterValueList">
                      {{filterValue}}
                      <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                        <i class="fas fa-times text-right"></i>
                      </a>
                    </mat-chip>
                  </mat-chip-set>
                </div>
              </div>
              <div class="col-sm-3 col-md-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
                <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <div class="legendBlock">
          <ul>
            <li class="yellow">NEW COMMENTS </li>
            <li class="blue">MANUAL PRODUCT LINE ADDED</li>
          </ul>
        </div>
        <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Active Return Requests
                </h4>
                <p class="subhead">
                  Add/Manage products for return.
                </p>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #returnRequestPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                  </div>
                  <button id="btnNewReturn" *ngIf="!readOnlyAccess && productLine!='All' && isProcessAccessed" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="createNewOrder()">New Return</button>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #returnRequestTable [dataSource]="returnRequestDataSource" matSort #returnRequestSort matSortDirection="desc" class="matTables">

                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Request ID</th>
                  <td mat-cell [ngClass]="{'error-row-outer':(element.status==='ERROR' || element.isComments || element.isManualLine)}" *matCellDef="let element" class="order-info defaultCursor">

                    <span [ngClass]="{'yellow-blue-symbol': (element.isComments && element.isManualLine), 'newComment-symbol':element.isComments, 'manualProd-symbol':element.isManualLine}">
                      <small></small>
                      <small></small>
                    </span>
                    <div *ngIf="element.totalProducts > 0 && element.totalUnits > 0" (click)="navigateOrderDetail(element,'active')" class="order-info handCursor">
                      <p class="accName">
                        {{element.returnRequestNumber}}
                      </p>
                    </div>
                    <div *ngIf="element.totalProducts == 0">
                      <p class="accName">
                        {{element.returnRequestNumber}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="purchaseOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO  text-center">Customer PO#</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.purchaseOrderNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center request-Id">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="order-info">
                      <p class="accName">
                        {{element.accountName}}
                      </p>
                      <p>
                        {{element.accountAddress1}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="dsmName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">SDM</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.dsmName}} </td>
                </ng-container>
                <ng-container matColumnDef="orderCreateDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Request Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderCreateDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="totalProducts">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="productName  text-center">Products</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.totalProducts}}</td>
                </ng-container>

                <ng-container matColumnDef="totalUnits">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units  text-center">Units</th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{element.totalUnits}}</td>
                </ng-container>
                <ng-container matColumnDef="emptyStockPalletCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units text-center">Empty Pallets</th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{element.emptyStockPalletCount}}</td>
                </ng-container>
                <ng-container matColumnDef="emptyCboxCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units text-center">Empty CBOX</th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{element.emptyCboxCount}}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center"> Status </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span class="statusMsg">
                      {{getStatusText(element.status)}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef class="actionBtn">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div>
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <button mat-menu-item (click)="viewOrderToInvoice(element)">View Return Order</button>
                      </mat-menu>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="returnRequestColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: returnRequestColumns;"></tr>
              </table>
              <div *ngIf="returnRequestList == undefined || returnRequestList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

          <mat-tab *ngIf="isProcessAccessed">
            <div class="col-md-2">
              <ng-template mat-tab-label>
                <i class="icon-ico-grower_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
                <div class="tab-head" id="draftTab">
                  <h4>
                    Return Request Drafts
                  </h4>
                  <p class="subhead">
                    Finish your draft to submit the request.
                  </p>
                </div>
              </ng-template>
            </div>

            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
                  <div class="display-ib wAuto">
                    <mat-paginator #returnRequestDraftPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>

            <div class="tableContainer draftReturnRequest">
              <table mat-table #returnRequestDraftTable [dataSource]="draftRequestDataSource" matSort #returnRequestDraftSort matSortDirection="desc" class="matTables">

                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Request ID</th>
                  <td mat-cell [ngClass]="{'error-row-outer':(element.status==='ERROR' || element.isComments || element.isManualLine)}" *matCellDef="let element" class="order-info defaultCursor">

                    <span [ngClass]="{'yellow-blue-symbol': (element.isComments && element.isManualLine), 'newComment-symbol':element.isComments, 'manualProd-symbol':element.isManualLine}">
                      <small></small>
                      <small></small>
                    </span>
                    <div (click)="navigateOrderDetail(element,'draft')" class="order-info handCursor">
                      <p class="accName">
                        {{element.returnRequestNumber}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="purchaseOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO text-center">Customer PO#</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.purchaseOrderNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center request-Id">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="order-info">
                      <p class="accName">
                        {{element.accountName}}
                      </p>
                      <p>
                        {{element.accountAddress1}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="dsmName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">SDM</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.dsmName}} </td>
                </ng-container>
                <ng-container matColumnDef="orderCreateDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Request Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderCreateDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="totalProducts">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Products</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.totalProducts}}</td>
                </ng-container>

                <ng-container matColumnDef="totalUnits">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units text-center">Units</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.totalUnits}}</td>
                </ng-container>
                <ng-container matColumnDef="emptyStockPalletCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units text-center">Empty Pallets</th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{element.emptyStockPalletCount}}</td>
                </ng-container>
                <ng-container matColumnDef="emptyCboxCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units text-center">Empty CBOX</th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{element.emptyCboxCount}}</td>
                </ng-container>
                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef class="actionBtn">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div *ngIf="!readOnlyAccess" title="Delete Draft">
                      <span class="action-btn" (click)="deleteOrder(element)">
                        <i class="fas fa-trash"></i>
                      </span>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="returnRequestDraftColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: returnRequestDraftColumns;"></tr>
              </table>
              <div *ngIf="returnRequestDraftList == undefined || returnRequestDraftList.length == 0" class="noDataMsg draftOrderHeight">
                <p>No Record Found.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
